/** Note composer picker: omits `createdBy`, which only the settings list shows. */
export const GET_NOTE_TEMPLATES = gql`
  query GET_NOTE_TEMPLATES(
    $pageInfo: PageInfoInput
    $orderBy: OrderByInput
    $search: String
  ) {
    noteTemplates(pageInfo: $pageInfo, orderBy: $orderBy, search: $search) {
      totalCount
      pageInfo {
        offset
        limit
      }
      items {
        noteTemplateId
        title
        content
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_NOTE_TEMPLATES_WITH_CREATOR = gql`
  query GET_NOTE_TEMPLATES_WITH_CREATOR(
    $pageInfo: PageInfoInput
    $orderBy: OrderByInput
    $search: String
  ) {
    noteTemplates(pageInfo: $pageInfo, orderBy: $orderBy, search: $search) {
      totalCount
      pageInfo {
        offset
        limit
      }
      items {
        noteTemplateId
        title
        content
        createdAt
        updatedAt
        createdBy {
          employeeId
          firstName
          lastName
        }
      }
    }
  }
`

export const RESOLVE_NOTE_TEMPLATE = gql`
  query RESOLVE_NOTE_TEMPLATE($noteTemplateId: String!, $applicantId: String!) {
    resolveNoteTemplate(
      noteTemplateId: $noteTemplateId
      applicantId: $applicantId
    ) {
      content
    }
  }
`

export const CREATE_NOTE_TEMPLATE = gql`
  mutation CREATE_NOTE_TEMPLATE($input: CreateNoteTemplateInput!) {
    createNoteTemplate(input: $input) {
      noteTemplateId
    }
  }
`

export const UPDATE_NOTE_TEMPLATE = gql`
  mutation UPDATE_NOTE_TEMPLATE(
    $noteTemplateId: String!
    $input: UpdateNoteTemplateInput!
  ) {
    updateNoteTemplate(noteTemplateId: $noteTemplateId, input: $input) {
      noteTemplateId
    }
  }
`

export const DELETE_NOTE_TEMPLATE = gql`
  mutation DELETE_NOTE_TEMPLATE($noteTemplateId: String!) {
    deleteNoteTemplate(noteTemplateId: $noteTemplateId) {
      noteTemplateId
    }
  }
`
